import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { convertDatesBackToTimestamps } from 'asset-actions-lib-forms/utils/formSavingUtils';
const PUBLISH_AND_DELETE_DRAFT_FIELD_NAME = 'publishedForm';
const PUBLISH_AND_DELETE_DRAFT = registerMutation({
  fieldName: PUBLISH_AND_DELETE_DRAFT_FIELD_NAME,
  args: ['formDefinition'],
  fetcher({
    formDefinition
  }) {
    return http.put(`/forms/v2/forms-drafts/publish/${formDefinition.guid}`, {
      data: convertDatesBackToTimestamps(formDefinition)
    });
  }
});
export default function usePublishAndDeleteDraft() {
  const [publishAndDeleteDraft, {
    loading
  }] = useMutation(PUBLISH_AND_DELETE_DRAFT);
  return {
    publishAndDeleteDraft: formDefinition => publishAndDeleteDraft({
      variables: {
        formDefinition
      }
    }).then(response => response.data ? response.data.publishedForm : undefined).catch(mutationError => {
      mutationError.cause = 'PUBLISH_FORM_DEFINITION_ERROR';
      throw mutationError;
    }),
    loading
  };
}